import orderBy from 'lodash/orderBy';
import isEmpty from 'lodash/isEmpty';

// noinspection JSAnnotator
export const eventDirectoryPageConstant = {
    constant: {
        myChapterDefaultFilter: {
            parentKey: 'sponsors',
            filter: {
                count: 0,
                filterKey: 'ExcludeOtherChaptersEvents',
                filterValue: '',
                isDropdown: false,
                isTypeAhead: false,
                label: "Exclude Other Chapter's Events",
                ribbonGroupName: 'Sponsors',
                subFilters: [],
            },
        },
        searchResultOffsetStep: 50,
        searchResultMaxCount: 50,
        minimumCountForRolodex: 10,
        selectedOneClickDateFilter: 'selectedOneClickDateFilter',
    },
    errors: {
        FROM_DATE_REQUIRED: 'From date required',
        TO_DATE_REQUIRED: 'To date required',
        FROM_DATE_BEFORE_TO_DATE: 'To date should be after from date!',
    },
};

export const datesRibbonFilters = [
    {
        key: 'FromRange',
        label: 'Start Date Earliest',
    },
    {
        key: 'ToRange',
        label: 'Start Date Latest',
    },
    {
        key: 'IncludePast90Days',
        label: 'Include events from the past 90 days',
    },
];

export const isButtonEnabled = (previouslySelected, newlySelected) => {
    let noData = true;

    if (previouslySelected && newlySelected && previouslySelected.length !== newlySelected.length) {
        noData = false;
    }

    if (previouslySelected && newlySelected && previouslySelected.length && newlySelected.length) {
        newlySelected.forEach((newItem) => {
            const commonItem = previouslySelected
                .find(prevItem => prevItem.filterValue === newItem.filterValue && prevItem.filterKey === newItem.filterKey);
            if (!commonItem) {
                noData = false;
            }
        });
    }
    return noData;
};

export const setLocalFilterData = (previouslySelected, filtersFromApi) => {
    const result = [];
    if (
        previouslySelected &&
        previouslySelected.length &&
        filtersFromApi &&
        filtersFromApi.filters &&
        filtersFromApi.filters.length
    ) {
        previouslySelected.forEach((item) => {
            const itemInApi = filtersFromApi.filters
                .find(it => it.filterKey === item.filterKey && it.filterValue === item.filterValue);
            if (itemInApi) {
                result.push(itemInApi);
            } else {
                result.push(item);
            }
        });
    }
    return result;
};

export const sortListAlphabeticallyAsc = (list) => {
    return list && list.length > 0 ? orderBy(list, ['label'], ['asc']) : [];
};

export const applyNumber = (previouslySelected, newlySelected) => {
    const result = [];

    if (previouslySelected && newlySelected && newlySelected.length) {
        newlySelected.forEach((newItem) => {
            const commonItem = previouslySelected
                .find(prevItem => prevItem.filterValue === newItem.filterValue && prevItem.filterKey === newItem.filterKey);
            if (!commonItem && newItem.filterValue && !newItem.isDropdown) {
                result.push(newItem);
            }
        });
    }
    return result.length > 0 ? result.length : null;
};

export const removeLetterFilterForRolodex = (routeQuery, router, sessionStorageConstant) => {
    let dataFromRoute = null;
    if (routeQuery) {
        dataFromRoute = { ...routeQuery };
        if (routeQuery.filters) {
            const filtersFromRoute = JSON.parse(routeQuery.filters);
            if (filtersFromRoute && filtersFromRoute.hasOwnProperty('letterFilter')) {
                delete filtersFromRoute.letterFilter;
            }

            if (isEmpty(filtersFromRoute)) {
                delete dataFromRoute.filters;
            } else {
                dataFromRoute.filters = { ...filtersFromRoute };
            }
        }
    }

    if (dataFromRoute) {
        if (dataFromRoute.filters) {
            dataFromRoute.filters = JSON.stringify(dataFromRoute.filters);
            sessionStorage.setItem(sessionStorageConstant, dataFromRoute.filters);
        } else {
            sessionStorage.removeItem(sessionStorageConstant);
        }
        router.push({
            query: { ...dataFromRoute },
        });
    }
};
